import { useContext } from "react";
import { AccountContext } from "./context";
import { IAccount } from "./types";

export function useAccount(): IAccount | undefined {
  const { account } = useContext(AccountContext);
  return account;
}
